import { render } from "./RecordForm.vue?vue&type=template&id=d8077424&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"

import "./RecordForm.vue?vue&type=style&index=0&id=d8077424&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8077424"]])

export default __exports__